<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol class="d-flex justify-content-end">
                    <ButtonCreate
                        :title="$t('Add email to blacklist')"
                        @click="modals.addEmailToBlacklist.show = true"
                    >
                        {{ $t("Add email") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.emailBlacklist.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'emailBlacklist',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.emailBlacklist.allFields
                                        "
                                        :activeFields.sync="
                                            tables.emailBlacklist.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.emailBlacklist.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.emailBlacklist.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :items-per-page="tables.emailBlacklist.rows"
                                    :loading="tables.emailBlacklist.loading"
                                    v-bind="tables.emailBlacklist"
                                    :columnFilterValue.sync="
                                        tables.emailBlacklist.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.emailBlacklist.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                >
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/headers.api/emails/blacklist"
                                                :table="tables.emailBlacklist"
                                            />
                                        </div>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.emailBlacklist
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'emailBlacklist',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.emailBlacklist.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.emailBlacklist.page"
                                    :pages="tables.emailBlacklist.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
                <AddEmailToBlacklistModal
                    :show.sync="modals.addEmailToBlacklist.show"
                    v-bind="modals.addEmailToBlacklist"
                    v-on:submit="afterEmailAddingToBlacklist"
                    :title="$t('Add email to blacklist')"
                />
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'emailBlacklist',
                    })
                "
            >
                <template #title>
                    {{ $t("Add email to blacklist") }}
                </template>
                <template #description>
                    {{ $t("You can add an email to blacklist.") }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        @click="modals.addEmailToBlacklist.show = true"
                    >
                        {{ $t("Add email") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'emailBlacklist',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('emailBlacklist'), updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
import NoItemsContainer from "~/components/NoItemsContainer";

import AddEmailToBlacklistModal from "../Components/AddEmailToBlacklistModal.vue";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilReload,
    cilPencil,
    cilChart,
    cilTrash,
    cilArrowThickFromRight,
    cilMediaStop,
    cilMediaPlay,
} from "@coreui/icons";

import EmailBlacklistTable from "../Config/Tables/EmailBlacklist";

export default {
    name: "EmailsBlacklistPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        TableSettings,
        ButtonExport,
        FilterFields,
        NoItemsContainer,
        AddEmailToBlacklistModal,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
        cilMediaPlay,
        cilMediaStop,
    },
    data() {
        return {
            tables: {
                emailBlacklist: EmailBlacklistTable,
            },
            modals: {
                addEmailToBlacklist: {
                    show: false,
                    color: "primary",
                    size: "lg",
                },
            },
        };
    },
    computed:{
        titlePage: function () {
            return "Emails blacklist";
        },
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.emailBlacklist.rows = newValue;
            this.updatePagination(this.tables.emailBlacklist.page);
        },
        async updatePagination(newValue) {
            this.tables.emailBlacklist.page = newValue;
            await this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "emailBlacklist",
                url: "/headers.api/emails/blacklist",
            });
            this.tables.emailBlacklist.itemSelected = null;
            this.tables.emailBlacklist.loading = false;
            this.updatePageLoading(false);
        },

        afterEmailAddingToBlacklist(response) {
            this.modals.addEmailToBlacklist.show = false;
            this.updateData();
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss">
</style>